import * as setConsumerEmail from './setEmail';
import * as removeEmail from './removeEmail';
import * as setRecommendations from './setRecommendations';
import * as setConsumerName from './setName';

const consumerActions = {
  ...setConsumerEmail,
  ...setConsumerName,
  ...removeEmail,
  ...setRecommendations
};

export default consumerActions;
